import React, { useContext } from "react";
import "./index.css";
import { AtendimentoContext } from "../../../../contexts/AtendimentoContext";
import stringHelper from "../../../../helpers/StringHelper";

export function ConteudoAtendentesModal({atendentes, handleSelecionarCorretor}){
  const {atendentesSelecionados} = useContext(AtendimentoContext);

  return (
    <div className="lista-atendentes-modal">
      {atendentes?.map((item, index)=>{
        const itemSelecionado = atendentesSelecionados?.includes(Number(item.id));
        return(
          <div 
            key={index} 
            className={`atendente-item ${itemSelecionado ? "selecionado" : ""}`} style={{borderColor: item.cor}}
            onClick={()=>{
              handleSelecionarCorretor(item);
            }}
          >
            <div 
              className={`icone-atendente `}
              style={{backgroundColor: itemSelecionado ? item.cor : "white", color: item.cor, borderColor: `${item.cor}`}}
            >
              {stringHelper.resolverIconeAtendente(item.nome)}
            </div>
            <span>{item.nome}</span>
          </div>
        )
      })}
    </div>
  )
}
